module.exports = __webpack_public_path__ + "img/image35.62075d3e.webp";